import { images } from '_/space-management/assets';
import { colors } from '_/space-management/constants/theme';
import { useAuth } from '_/space-management/hooks/AuthContext';
import { Lang } from '_/space-management/services/models/enums/lang.enum';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View, Image } from 'react-native';
import { showMessage } from 'react-native-flash-message';
import Modal from 'react-native-modal';

import Button from '../Button';
import DropdownInput from '../DropdownInput';
import Title from '../Title';
import { ChangeLanguageModalProps } from './interface';
import styles from './styles';
import { useLanguage } from '_/hooks/LanguageContext';

export default function ChangeLanguageModal({
  visible,
  handleClose,
  selectedLanguage,
  setSelectedLanguage,
}: ChangeLanguageModalProps) {
  const { changeLanguage, language: defaultLanguage } = useLanguage();
  const [language, setLanguage] = useState<Lang>(defaultLanguage as any);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const languageOptions = [
    {
      label: t('spaceManage.language.pt-BR'),
      value: Lang.PTBR,
      icon: () => <Image source={images.brazilFlag} style={styles.flags} />,
    },
    {
      label: t('spaceManage.language.en'),
      value: Lang.EN,
      icon: () => <Image source={images.usFlag} style={styles.flags} />,
    },
  ];

  const handleChangeLanguage = useCallback(async () => {
    try {
      setLoading(true);
      changeLanguage(selectedLanguage || language);
      showMessage({
        message: t('spaceManage.success'),
        description: t('spaceManage.changeLanguageModal.successMessage'),
        backgroundColor: colors.successGreen,
      });
      handleClose();
    } catch (error) {
      showMessage({
        message: t('spaceManage.error'),
        description: t('spaceManage.changeLanguageModal.errorMessage'),
        backgroundColor: colors.errorRed,
      });
    }
    setLoading(false);
  }, [changeLanguage, handleClose, language, selectedLanguage, t]);

  return (
    <Modal
      style={styles.modal}
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={visible}
      coverScreen
      hasBackdrop
      backdropOpacity={0.5}
      onBackdropPress={handleClose}
      onBackButtonPress={handleClose}
      onSwipeStart={handleClose}
    >
      <Title title={t('spaceManage.profileScreen.chooseLanguangeButton.chooseLanguage')} />
      <View style={styles.wrapper}>
        <DropdownInput
          options={languageOptions}
          setValue={setSelectedLanguage || setLanguage}
          value={selectedLanguage || language}
        />
        <Button
          backgroundColor={colors.lightBlue}
          textColor={colors.clear}
          onPress={handleChangeLanguage}
          loading={loading}
        >
          {t('spaceManage.confirm')}
        </Button>
      </View>
    </Modal>
  );
}
